
import { Component, Vue, Prop } from "nuxt-property-decorator";
@Component
export default class GroupSoggetti extends Vue {
  @Prop() data!: any;
}
